import { AUTH_QUERY_VALUES, AUTH_SESSION_KEYS } from "@/constants/authFlowKeys";

const FEDERATION_REDIRECT_TTL_MS = 10 * 60 * 1000;

const parseStoredValue = (value) => {
  if (!value) {
    return null;
  }

  if (value === AUTH_QUERY_VALUES.TRUE) {
    return {
      startedAt: Date.now(),
    };
  }

  try {
    const parsedValue = JSON.parse(value);
    if (typeof parsedValue?.startedAt !== "number") {
      return null;
    }

    return parsedValue;
  } catch {
    return null;
  }
};

const getLocalValue = () => {
  return parseStoredValue(
    localStorage.getItem(AUTH_SESSION_KEYS.FEDERATION_REDIRECT_IN_PROGRESS),
  );
};

const isExpired = (state) => {
  return !state || Date.now() - state.startedAt > FEDERATION_REDIRECT_TTL_MS;
};

export const clearFederationRedirectState = () => {
  // Clear both scopes to clean up any older tab-local state left behind by
  // earlier implementations, but only localStorage is authoritative now.
  localStorage.removeItem(AUTH_SESSION_KEYS.FEDERATION_REDIRECT_IN_PROGRESS);
  sessionStorage.removeItem(AUTH_SESSION_KEYS.FEDERATION_REDIRECT_IN_PROGRESS);
};

export const setFederationRedirectState = () => {
  const nextState = JSON.stringify({
    startedAt: Date.now(),
  });

  localStorage.setItem(
    AUTH_SESSION_KEYS.FEDERATION_REDIRECT_IN_PROGRESS,
    nextState,
  );
};

export const getFederationRedirectState = () => {
  const localValue = getLocalValue();
  if (localValue && !isExpired(localValue)) {
    return true;
  }

  // Expired or malformed redirect markers should not keep future tabs stuck in
  // a redirecting state.
  clearFederationRedirectState();
  return false;
};
